import { Tree, Input, Button,Form, Modal,Select,message } from 'antd';
import React, { Component, useState } from 'react';
import { sagaModal } from 'redux-saga-modal'
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import * as apis from '@/apis'
const { Search } = Input;

class SendNotifyDialog extends Component {
    state = {
        options: [],
        selected: []
    };
    onChange = selected => {
        this.setState({selected})
    };
   
    queryTeant = async () => {
        this.setState({ loading: true })
        const result = await apis.queryTenants()
        let teants = []
        result.data.forEach(item => {
            teants.push({name:item.short_name,id:item._id})
        });
        this.setState({
            options:teants
        })
    };
    componentDidMount(){
        this.queryTeant()
    };
    sendNotify = async () => {
        const {  notify ,onSuccess} = this.props
        if(!notify._id){
            return
        }
        const receivers = this.state.selected
        if(receivers.length==0){
            message.error('请选择发送的企业');
            return
        }
        const result = await apis.sendNotify(notify._id, {receivers})
        if(result){
            onSuccess()
            message.success('发送成功');
        } else {
            message.error('发送失败');
        }
    };
    sendAll = async () => {
        const {  notify ,onSuccess} = this.props
        if(!notify._id){
            return
        }
        const result = await apis.sendNotify(notify._id)
        if(result){
            onSuccess()
            message.success('发送成功');
        } else {
            message.error('发送失败');
        }
    };
    render() {
        return (
          <div>
              <Select mode="multiple" optionFilterProp="title"  placeholder="搜索" style={{width:"100%"}} onChange={this.onChange}>
              {
                this.state.options.map(ele => {
                    return <Select.Option key={ele.id} title={ele.name} value={ele.id}>{ele.name}</Select.Option>
                })
              }
              </Select>
              <div style={{textAlign:'right',marginTop:'10px'}}>
              <Button type="primary" onClick={this.sendNotify}>发送选中</Button>
              <Button style={{marginLeft:'10px'}} type="primary" onClick={this.sendAll}>发送全部</Button>
              </div>
          </div>)
    }
}

const SendNotifyInfoDialog = ({
    modal,
    isOpen,
    show,
    update,
    destroy,
    click,
    submit,
    hide,
    showModal,
    updateModal,
    submitModal,
    clickModal,
    hideModal,
    destroyModal,
    ...ownProps
  }) => (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={480}
      style={{ top: 30 }}
      visible={isOpen}
      onCancel={hide}>
      <SendNotifyDialog onSuccess={hide} {...ownProps} />
    </Modal>
  )
  
  export default sagaModal({
    name: 'SEND_NOTIFY_DIALOG',
  })(SendNotifyInfoDialog)